/**
 * Model to save Time Keeping Details.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class TimesheetModel {
    clientId: number;
    date: Date;
    hours: number;
    activity: string;
    description: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/timesheet.model.ts